import { Divider, Grid, Group, Skeleton, Space, Text } from '@mantine/core';
import XSkeleton1Fields from '../../x-components/x-skeletons/x-skeleton-1-fields.component';
import XSkeleton3Fields from '../../x-components/x-skeletons/x-skeleton-3-fields.component';
import XSkeleton4Fields from '../../x-components/x-skeletons/x-skeleton-4-fields.component';

function SkeletonAdminUserInformation(props: Props) {
  const { skeletonHeight, skeletonWidth } = props;
  const height = skeletonHeight ?? 14;
  const width = skeletonWidth ?? '100%';

  const labels = {
    firstName: 'First name',
    middleName: 'Middle name',
    lastName: 'Last name',
    streetAddress: 'Street address',
    bldgNameNo: 'Building name and number',
    city: 'City',
    province: 'Province',
    barangay: 'Barangay',
    postalCode: 'Postal code',
    country: 'Country',
    contactNumber: 'Primary contact number',
    fax: 'FAX',
    mobileNumber: 'Mobile phone number',
    emailAddress: 'Email address',
    username: 'Username',
  };

  return (
    <>
      <Text size='xl' weight={700}>
        User Information
      </Text>
      <Space h='xl' />
      <Grid>
        <XSkeleton4Fields />
        <XSkeleton1Fields />
      </Grid>

      <Divider my='xl' />
      <Text size='xl' weight={700}>
        Address
      </Text>
      <Space h='xl' />
      <Grid>
        <XSkeleton4Fields />
        <XSkeleton3Fields />
      </Grid>

      <Divider my='xl' />
      <Text size='xl' weight={700}>
        Contact Information
      </Text>
      <Space h='xl' />
      <Grid>
        <XSkeleton3Fields />
      </Grid>
      <Space />
      <Divider my='xl' />

      <Space h='xl' />

      <Grid>
        <Grid.Col>
          <Group>
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
          </Group>
        </Grid.Col>
        <Grid.Col span={12}>
          <Group>
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
          </Group>
        </Grid.Col>
        <Grid.Col span={12}>
          <Group>
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
            <Skeleton height={skeletonHeight ?? height} width={'20%'} />
          </Group>
        </Grid.Col>
      </Grid>
    </>
  );
}

interface Props {
  skeletonHeight?: number;
  skeletonWidth?: number | string;
}

export default SkeletonAdminUserInformation;
